<mat-icon matPrefix class="notranslate" color="primary">calendar_month</mat-icon>
<div class="date-range-button" aria-label="Open filter by date range dialog" (click)="selectDates()" [ngClass]="{ 'small-font': !isEmptyRange }">
  {{rangePlaceholder}}
</div>
<mat-icon matSuffix *ngIf="showClearFilter" (click)="clearRange()" class="no-margin cursor-pointer notranslate" matTooltip="Clear" aria-label="Clear">clear</mat-icon>
